module.exports = "/_next/static/images/5077f65b85c110d0b6c41b185a1a3aea-doc.svg.webp";